import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
import React, { useState } from "react";
import "./style.scss";
import { Card } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { revisedFaqConfig } from "../../../../Utils/staticData";

const FAQ = () => {
  const [showTextArray, setShowTextArray] = useState(
    Array(revisedFaqConfig.length + 1).fill(true)
  );

  const toggleTextVisibility = (index) => {
    const updatedShowTextArray = [...showTextArray];
    updatedShowTextArray[index] = !updatedShowTextArray[index];
    setShowTextArray(updatedShowTextArray);
  };

  return (
    <div className="faq-container" id="faq">
      <div className="section-header">
        <Title level={2} className="section-heading">
          Frequently Asked Questions
        </Title>
        <Paragraph className="section-subtext">
          Answers for both candidates and hiring teams
        </Paragraph>
      </div>
      <div className="faq-card-wrapper">
        {revisedFaqConfig.map((item) => (
          <Card
            className="faq-card"
            key={item?.id}
            onClick={() => toggleTextVisibility(item?.id)}
          >
            <div className="content">
              <div className="faq-card-heading">{item?.heading}</div>
              {!showTextArray[item?.id] && (
                <div className="faq-card-text">{item?.text}</div>
              )}
            </div>
            <div className="icon">
              <p className={`${showTextArray[item?.id] ? "" : "hide"}`}>
                {showTextArray[item?.id] ? <PlusOutlined /> : <MinusOutlined />}
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
